import { Dispatch, SetStateAction } from 'react';

import { Dialog } from '@/components/Dialog';

import PostGenerationBody from './PostGenerationBody';
import PreGenerationBody from './PreGenerationBody';
import useGenerationBody from './useGenerationBody';

const KeyDialog = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { generated, handleClose } = useGenerationBody();
  return (
    <Dialog
      open={open}
      title='Generate new API token'
      onClose={() => {
        setOpen(false);
      }}
    >
      {generated ? (
        <PostGenerationBody
          handleClose={() => {
            handleClose(setOpen);
          }}
        />
      ) : (
        <PreGenerationBody
          handleClose={() => {
            handleClose(setOpen);
          }}
        />
      )}
    </Dialog>
  );
};
export default KeyDialog;
